import React, { lazy } from 'react';
const testimonials = [{
  text: 'Ich lebe seit 8 Jahren mit Typ-2-Diabetes. Die Desserts aus Buch 4 haben mich zum Weinen gebracht — vor Freude. Mein Arzt kann es nicht glauben.',
  author: 'Monika S., Frankfurt',
  image: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  text: 'Glutenunverträglichkeit hat mein Leben kompliziert. Mit METABOLIK PRO esse ich wieder wie ein normaler Mensch — und alles schmeckt wirklich gut.',
  author: 'Hans-Peter W., München',
  image: 'https://randomuser.me/api/portraits/men/52.jpg'
}, {
  text: '500 Rezepte und ich habe noch nicht mal alle ausprobiert. Das erste System, das wirklich in meinen Alltag passt.',
  author: 'Ingrid K., Hamburg',
  image: 'https://randomuser.me/api/portraits/women/75.jpg'
}, {
  text: 'Endlich kein Blutzucker-Crash mehr nach dem Mittagessen. Die Hauptgerichte sind schnell gemacht und meine ganze Familie isst sie gerne mit.',
  author: 'Thomas L., Berlin',
  image: 'https://randomuser.me/api/portraits/men/64.jpg'
}, {
  text: 'Ich dachte, ohne Zucker bedeutet ohne Geschmack. Dieses System hat mich eines Besseren belehrt. Ich habe mehr Energie als je zuvor.',
  author: 'Sabine M., Stuttgart',
  image: 'https://randomuser.me/api/portraits/women/57.jpg'
}];
export function Testimonials() {
  return <section className="py-8 sm:py-12 px-4 bg-brand-sage-light" data-id="element-179">
      <div className="max-w-xl mx-auto" data-id="element-180">
        <div className="text-center mb-6 sm:mb-8" data-id="element-181">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-text-main mb-2" data-id="element-182">
            Das sagen unsere Kunden
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-183">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-brand-sage/20 p-5 sm:p-6 rounded-xl shadow-sm" data-id="element-184">
              <div className="text-brand-gold mb-2 text-sm" data-id="element-185">⭐⭐⭐⭐⭐</div>
              <p className="text-brand-text-main font-medium mb-3 sm:mb-4 text-sm sm:text-base leading-snug" data-id="element-186">
                "{t.text}"
              </p>
              <div className="border-t border-brand-sage/10 pt-3 flex items-center gap-3" data-id="element-187">
                <img src={t.image} alt={t.author} loading="lazy" className="w-9 h-9 sm:w-10 sm:h-10 rounded-full object-cover shrink-0" data-id="element-188" />
                <span className="text-xs sm:text-sm text-brand-text-muted font-bold" data-id="element-189">
                  {t.author}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}